import {Price} from "@vfit/shared/atoms";
import {IOfferDetailsTyP} from "@vfit/shared/models";
import { OfferDetailsContainer, OfferTitleSmall } from "./summary.style";

export const OfferDetails = ({category, price, originalPrice, description, recurrence, specs} : IOfferDetailsTyP) =>
   (
    <OfferDetailsContainer>
      {/* eslint-disable-next-line react/destructuring-assignment */}
      <OfferTitleSmall>{category}</OfferTitleSmall>
      <Price amount={price || ''} recurrence={recurrence} oldAmount={originalPrice} detail={description} specs={specs} />
    </OfferDetailsContainer>
  )

